import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import { Button } from 'antd';
import styles from "@/styles/article/return-policy.module.scss"
import Link from 'next/link'
export default function PrivacyStatement() {

  return (
    <>
      <Head>
        <title>
          Online Shopping New Zealand - Beauty & Health, Computers, Toys, - Deals & Discounts | BestDeals
        </title>
        <meta
          name="keywords"
          content="Online Shopping New Zealand, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, BestDeals"
        ></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout >
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['content']}>
            <div className={styles['content-title']}>Privacy Policy</div>

            <div className={`${styles['ask-title']} padding-top-24`}>Effective date of this privacy policy. [7-11-2013]</div>

            <div className={styles['answer-desc']}>
              {`this web site is subject to the New Zealand Privacy Act 1993 (“Act”). This privacy policy explains in general terms how we are committed to protecting your privacy and your personal information. It will apply to any personal information you provide to us when registering with us on this website. It also describes the choices available to you regarding our use of your personal information and how you can access and update this information.`}
              {/* <Link
                href="https://www.BestDeals.com.au/"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  &nbsp;www.BestDeals.com.au&nbsp;
                </a>
              </Link> */}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              What Information Do We Collect?
            </div>
            <div className={styles['answer-desc']}>
              {`The types of personal information that we collect from you will depend on the circumstances of collection and on the type of service you request from us. For example, when you wish to purchase a product from this website we may collect details such as your name, address, delivery address, telephone numbers and other information relevant to your purchase.`}
            </div>
            <div className={styles['answer-desc']}>
              {`As we are required by law to obtain your consent to the collection of "sensitive information" (such as address, name and phone number), we will assume that you have given consent to the collection of all information you have provided to us for use in accordance with this privacy policy, unless you tell us otherwise.`}
            </div>

            <div className={styles['answer-desc']}>
              {`We may use the information we collect to notify you about important changes to our website, new and special offers we think you might be interested. If at any stage you no longer wish to receive these notifications you may opt out by sending us an email.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              How Do We Collect Information?
            </div>
            <div className={styles['answer-desc']}>
              {`We may collect personal information about you when you visit our website, when you deal with us over the telephone, send us correspondence (whether by letter, fax or email), or when you have contact with us in person. We will not collect any personal information without your consent. You acknowledge that your consent is granted when you complete the fields necessary to facilitate a transaction through this website.`}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              How Do We Use Your Personal Information?<br />
              We generally collect your personal information for the following purposes:
            </div>
            <div className={styles['answer-desc']}>
              To assist us in providing you with a quality service
            </div>
            <div className={styles['answer-desc']}>
              To facilitate your access to our website, products and services
            </div>
            <div className={styles['answer-desc']}>
              To deliver products you have ordered from us
            </div>
            <div className={styles['answer-desc']}>
              To conduct marketing activities
            </div>
            <div className={styles['answer-desc']}>
              To provide you with information about our products and services
            </div>
            <div className={styles['answer-desc']}>
              To seek your opinion on our products, services, marketing and website.
            </div>
            <div className={styles['answer-desc']}>
              To send you newsletters
            </div>

            <div className={styles['answer-desc']}>
              {`Some of the personal information we collect is essential for us to be able to accurately identify who is using the service. Other types of personal information we collect help us to develop a profile of who is using our service and what their interests are this assists us in offering products to suit the needs of the users of this website. This information will only be used for the purpose for which you have provided it.`}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Disclosure of Personal Information to Third Parties
            </div>
            <div className={styles['answer-desc']}>
              {`We may disclose your personal information to third parties for the purpose for which the information was collected or for related purposes, for example to complete a transaction on your behalf or provide you with a product that you purchased. We engage third party contractors to perform services for us which involves the contractor handling personal information we hold. For example, we currently engage third party contractors to:`}
            </div>
            <div className={styles['answer-desc']}>
              Deliver products purchased from this website
            </div>
            <div className={styles['answer-desc']}>
              Provide electronic funds transfer services, credit card account processing and related services
            </div>

            <div className={styles['answer-desc']}>
              {`In these situations, the third party contractor is strictly prohibited from using any personal information about you, except for the specific purpose for which we have supplied. We may also disclose your personal information to various law enforcement agencies and governments around the world for security, to comply with a subpoena, customs and immigration purposes. Other than the above, we will not disclose your personal information without your consent unless disclosure is either necessary to prevent a threat to life or health, authorised or required by law, reasonably necessary to enforce the law or necessary to investigate a suspected unlawful activity.`}
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Access & Correction of Information About You
            </div>
            <div className={styles['answer-desc']}>
              {`We will, on request, provide you with access to the information we hold about you, unless there is an exception which applies under the Act, including for the purpose of correcting or updating that information. We may recover from you our reasonable costs of supplying you with access to this information. Your request to provide access to this information will be dealt with within in a reasonable time. If we refuse to provide you with access to the information, we will provide you with reasons for the refusal and inform you of any exceptions relied upon under the Act`}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Keeping Your Personal Information Up To Date
            </div>
            <div className={styles['answer-desc']}>
              {`We take reasonable steps to ensure that your personal information is accurate, complete, and up-to-date whenever we collect or use it. If the personal information we hold about you is inaccurate, incomplete or out-of-date, please contact us and we will take reasonable steps to either correct this information, or if necessary, discuss alternative action with you.`}
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Updating/Accessing/Amending/Correcting Personally Identifiable Information
            </div>
            <div className={styles['answer-desc']}>
              {`If your personally identifiable information changes, or if you no longer desire our service, you may update it by making the change on our member information page or by emailing our Customer Support at info@bestdeals.co.nz.`}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Choice/Opt-Out
            </div>
            <div className={styles['answer-desc']}>
              {`You may choose to stop receiving our newsletter or marketing emails by filling in the Unsubscribe Form, or you can contact us at info@bestdeals.co.nz.`}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Cookies and Other Tracking Technologies
            </div>
            <div className={styles['answer-desc']}>
              {`We may use cookies, for example, to keep track of your preferences and profile information. Cookies are also used to collect general usage and volume statistical information that does not include personal information.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Third Party Cookies
            </div>
            <div className={styles['answer-desc']}>
              {`The use of cookies by our affiliates, tracking utility company and service providers are not covered by our privacy policy. We do not have access or control over these cookies. Our affiliates, tracking utility company and service providers use session ID cookies to make it easier for you to navigate our site, in order for you to use the shopping cart, etc.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Web beacons
            </div>
            <div className={styles['answer-desc']}>
              {`Our Web pages contain electronic images known as Web beacons (sometimes called single-pixel gifs) and are used along with cookies to compile aggregated statistics to analyze how our site is used and may be used in some of our emails to let us know which emails and links have been opened by recipients. This allows us to gauge the effectiveness of our customer communications and marketing campaigns.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Tell-A-Friend
            </div>
            <div className={styles['answer-desc']}>
              {`If you choose to use our referral service to tell a friend about our site, we will ask you for your friend’s name and email address. We will automatically send your friend a one-time email inviting him or her to visit the site. Best Deals stores this information for the sole purpose of sending this one-time email and tracking the success of our referral program. Your friend may contact us at `}
              <a
                className={styles['link']}
                href="mailto:info@bestdeals.co.nz"
              >
                &nbsp;info@bestdeals.co.nz&nbsp;
              </a>
              {` to request that we remove this information from our database.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Links to Other Web Sites
            </div>
            <div className={styles['answer-desc']}>
              {`Our Site includes links to other Web sites whose privacy practices may differ from those of Best Deals. If you submit personal information to any of those sites, your information is governed by their privacy policies. We encourage you to carefully read the privacy policy of any Web site you visit.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Blogs
            </div>
            <div className={styles['answer-desc']}>
              {`Our Web site offers publicly accessible blogs or community forums. You should be aware that any information you provide in these areas may be read, collected, and used by others who access them.`}
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Live Chat
            </div>
            <div className={styles['answer-desc']}>
              {`We may use a live chat feature to assist you with customer services. If our chat feature is offline we will collect your name and email address so that we may reply to your request. We will email you a full live chat history at end of live chat service.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Surveys or Contests
            </div>
            <div className={styles['answer-desc']}>
              {`From time-to-time we may provide you the opportunity to participate in contests or surveys on our site. If you participate, we will request certain personally identifiable information from you. Participation in these surveys or contests is completely voluntary and you therefore have a choice whether or not to disclose this information. The requested information typically includes contact information (such as name and shipping address), and demographic information (such as post code).`}
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Security of Your Personal Information
            </div>
            <div className={styles['answer-desc']}>
              We will securely hold your personal information and we will not trade, rent or sell it.
            </div>
            <div className={styles['answer-desc']}>
              We will take all reasonable steps to keep secure any information which we hold about you. Personal information may be stored both electronically on our computer system, and in hard-copy form. Firewalls, SSL encryption, passwords, anti-virus software and email filters act to protect all our electronic information.
            </div>
            <div className={styles['answer-desc']}>
              {`We take all necessary measures to ensure the security of hard-copy information.`}
            </div>
            <div className={styles['answer-desc']}>
              {`Once your transaction is finalised, both the electronic and hard-copy information are securely archived. After a period of 7 years, both the electronic and hard-copy information will be destroyed.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Data Retention
            </div>
            <div className={styles['answer-desc']}>
              {`If you wish to cancel your account or request that we no longer use your information to provide you services contact us at `}
              <a
                className={styles['link']}
                href="mailto:info@bestdeals.co.nz"
              >
                &nbsp;info@bestdeals.co.nz&nbsp;
              </a>
              {` We will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Resolving Your Concerns
            </div>
            <div className={styles['answer-desc']}>
              {`If you wish to gain access to your personal information, have a complaint about a breach of your privacy or you have any query on how your personal information is collected or used please forward your request, complaint or query to the address below. We will respond to your query or complaint as soon as possible. Email: `}
              <a
                className={styles['link']}
                href="mailto:info@bestdeals.co.nz"
              >
                &nbsp;info@bestdeals.co.nz&nbsp;
              </a>
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Changes to This Privacy policy
            </div>
            <div className={styles['answer-desc']}>
              {`We may amend this privacy policy as our business requirements or the law changes. Any changes to this privacy policy will be updated on www.bestdeals.co.nz, so please visit this page periodically to ensure that you have our most current privacy policy.`}
            </div>
            <div className={styles['answer-desc']}>
              {`If we make any material changes we will notify by means of a notice on this website prior to the change becoming effective.`}
            </div>

            <Button
              type="primary"
              href="/"
              className={styles['continue-shopping-btn']}
            >
              Continue Shopping
            </Button>

          </div>
        </div>
      </DefaultLayout>
    </>
  )
}